export default __webpack_public_path__ + "static/media/illustration-algocare-m@2x.18a20903.webp";